import {useTranslation} from "ni18n";
import React from "react";

import {usePartnersConstants} from "../../../constants/Partners";
import ColorCard from "../BenefitsColorCard";
import {Btn} from "../V5Comp";

const Benefits: React.FC = () => {
  const i18n = useTranslation();

  const {benefits, ctaProps} = usePartnersConstants();

  return (
    <section className="ph8 pv30 pv10-md contrast-tbb" aria-labelledby="benefits-heading">
      <div className="maxw70 ma">
        <h2 className="mb5 tac-md" id="benefits-heading">
          {i18n.t("How we work with our partners")}
        </h2>

        <div className="pv8 mb4 dg gg6 af df-sm fw jcc-md">
          {benefits.map(b => (
            <ColorCard key={b.header} {...b} className="mb3-sm" />
          ))}
        </div>

        <div className="tac-md">
          <Btn {...ctaProps} />
        </div>
      </div>
    </section>
  );
};

export default Benefits;
